export const RedocOptions = {
    theme: {
        typography: {
            fontFamily: 'MuseoSansW05', // OCRAStd
        },
        spacing: {
            sectionVertical: 24,
        },
    },
    optimizeSpeed: true,
    pathInMiddlePanel: true, // moves path above the description (not allowed to set the position any other way)
    hideLoading: true,
    disableSearch: true,
};

